// extracted by mini-css-extract-plugin
export default {"container":"PromoPremiumToUltimatePaywall_container__rxLB7"};